import { useEffect, useState } from 'react';
import { Alert, Button, SpaceBetween } from '@amzn/awsui-components-react';

import {
    getDrishtiInstallGuide,
    isGetDrishtiInstallGuideResponse,
    type ErrorResponse,
} from '../services/drishtiHandler';
import { EventName, EventType, logDrishtiMetricEvent } from '../services/eventService';

const GUIDE_ERROR = 'Installation guide: could not load the guide.';

const errorMessageOf = (result: unknown) =>
    typeof result === 'object' && result !== null ? (result as ErrorResponse).message : undefined;

const guideErrorFor = (result: unknown) => {
    const message = errorMessageOf(result);
    return message ? `${GUIDE_ERROR} (${message})` : GUIDE_ERROR;
};

// Fetched on render, not on the click: mobile browsers block a tab opened from an async callback.
const DrishtiInstallGuideLink = () => {
    const [guideUrl, setGuideUrl] = useState('');
    const [guideError, setGuideError] = useState('');
    const [loading, setLoading] = useState(true);

    const loadGuide = () => {
        setLoading(true);
        setGuideError('');
        getDrishtiInstallGuide((success, result) => {
            setLoading(false);
            if (success && isGetDrishtiInstallGuideResponse(result)) {
                setGuideUrl(result.url);
                logDrishtiMetricEvent({
                    eventName: EventName.DRISHTI_INSTALL_GUIDE_LOADED,
                    eventType: EventType.SUCCESS,
                });
                return;
            }
            setGuideError(guideErrorFor(result));
            logDrishtiMetricEvent({
                eventName: EventName.DRISHTI_INSTALL_GUIDE_LOADED,
                eventType: EventType.FAILURE,
                miscEventData: { error: errorMessageOf(result) },
            });
        });
    };

    useEffect(loadGuide, []);

    return (
        <SpaceBetween size="xs">
            <Button
                iconName="external"
                href={guideUrl}
                target="_blank"
                rel="noopener noreferrer"
                loading={loading}
                disabled={!guideUrl}
            >
                Open the installation guide
            </Button>

            {guideError ? (
                <Alert type="error" action={<Button onClick={loadGuide}>Retry</Button>}>
                    {guideError}
                </Alert>
            ) : null}
        </SpaceBetween>
    );
};

export default DrishtiInstallGuideLink;
